import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { SubmitHandler, useForm } from 'react-hook-form';
import styled from 'styled-components';

type Props = {
    onSubmitStart: any;
};
type FormData = {
    memoContent: string;
};

const defaultValues: FormData = {
    memoContent: ''
}

const ShowForm = (props: Props) => {
    const { onSubmitStart } = props;
    const { handleSubmit, reset, register, formState: { errors } } = useForm<FormData>({ defaultValues });
    const onSubmit: SubmitHandler<FormData> = (data: FormData) => {
        reset();
        onSubmitStart(data);
    };
    return (
        <FormWithStyled>
            <Form.Control
                as='textarea'
                placeholder='特別な連絡事項がありましたら、こちらに入力して下さい。'
                {...register('memoContent', { required: true })}
            />
            {errors.memoContent && <ErrorWithStyled>メモを入力してください。</ErrorWithStyled>}
            <FormButtonWithStyled>
                <Button
                    variant='primary'
                    size='sm'
                    onClick={handleSubmit(onSubmit)}
                >メモ登録</Button>
            </FormButtonWithStyled>
        </FormWithStyled>
    );
};

const FormWithStyled = styled.form`
    margin: 5px 0 0;
`
const FormButtonWithStyled = styled.div`
    margin: 5px 0;
    & > .btn {
        min-width: 100px;
    }
`
const ErrorWithStyled = styled.span`
    color: #dc3545;
    display: inline-block;
    margin-top: 5px;
`

export default ShowForm;